import { render } from "./StatisticLabelsOperations.vue?vue&type=template&id=7303da63&ts=true"
import script from "./StatisticLabelsOperations.vue?vue&type=script&lang=ts"
export * from "./StatisticLabelsOperations.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__